export default __webpack_public_path__ + "static/media/SunOutlineIcon.86d7080a.svg";